/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Injectable } from '@angular/core';

import { DataQuery } from '@typescript-kit/data';
import { HttpService } from '@angular-kit/core';

import { Comment, CommentData } from '@teamworks/global';

@Injectable()
export class CommentService {

  constructor(private httpService: HttpService) {
  }

  async loadCommentList(employeeId: string, dataQuery?: DataQuery): Promise<Comment[]> {
    return this.httpService.get(`api/time-recording/comment-list/${employeeId}`, { 'data-query': dataQuery })
      .then((loadedData: CommentData[]) => loadedData.map(data => new Comment(data)));
  }

  async loadComment(employeeId: string, type: string, date: string, dataQuery?: DataQuery): Promise<Comment> {
    return this.httpService.get(`api/time-recording/comment/${employeeId}/${type}/${date}`, { 'data-query': dataQuery })
      .then((loadedData: CommentData) => loadedData && new Comment(loadedData));
  }

  async saveComment(data: CommentData): Promise<Comment> {
    return this.httpService.post(`api/time-recording/comment`, data)
      .then((savedData: CommentData) => new Comment(savedData));
  }

  async deleteComment(employeeId: string, type: string, date: string): Promise<Comment> {
    return this.httpService.delete(`api/time-recording/comment/${employeeId}/${type}/${date}`)
      .then((deletedData: CommentData) => new Comment(deletedData));
  }
}
